module.exports = __webpack_public_path__ + "img/gym-colored.a97f94a.svg";